#import "./StaffTrainingModuleFields.graphql"

mutation CompleteTrainingModule($moduleId: ID!) {
  completeTrainingModule(input: { moduleId: $moduleId }) {
    trainingModule {
      ...StaffTrainingModuleFields
    }
  }
}
